import logo from "../assets/images/logo.png";

export const Footer = () => {
  return (
    <>
      <footer className="d-flex container flex-wrap justify-content-between align-items-center py-3 my-4">
        <a
          href="/"
          className="col-md-6 d-flex align-items-center mb-3 mb-md-0 me-md-auto link-body-emphasis text-decoration-none"
        >
          <img src={logo} width="100px" alt="logo" />
        </a>

        <p className="col-md-6 d-flex justify-content-md-end mb-0">© 2026 1AutoTransfer.lv</p>
      </footer>
    </>
  );
};
